const idsEqual = (left, right) => {
  if (left === null || left === undefined || right === null || right === undefined) {
    return false;
  }

  return String(left) === String(right);
};

const hasTicketQueueAccess = (ticket, user) => {
  if (!ticket?.queueId) {
    return true;
  }

  const userQueues = Array.isArray(user?.queues) ? user.queues : [];
  if (userQueues.length === 0) {
    return true;
  }

  return userQueues.some(queue => idsEqual(queue?.id, ticket.queueId));
};

export const isTicketNotificationCandidate = (ticket, includePending = false) => {
  if (!ticket || ticket.status === "closed") {
    return false;
  }

  if (ticket.status === "pending") {
    return Boolean(includePending);
  }

  return Number(ticket.unreadMessages || 0) > 0 || Boolean(ticket.manualFlag);
};

export const canShowTicketNotification = (ticket, user, includePending = false) => {
  if (!user || !isTicketNotificationCandidate(ticket, includePending)) {
    return false;
  }

  if (!hasTicketQueueAccess(ticket, user)) {
    return false;
  }

  if (ticket.status === "pending") {
    return Boolean(includePending);
  }

  return Boolean(ticket.isShared) || idsEqual(ticket.userId, user.id);
};
